import React from "react";
import { Box } from "@mui/material";
import TicketsScreen from "../../components/ticketsScreen";

/**
 * Listado de facturas adeudadas del cliente.
 *
 * Es un envoltorio: la tabla y sus filtros viven en `TicketsScreen`. Acá sólo
 * se le da el ancho. El `clear: both` de antes compensaba los `float` de la
 * hoja vieja, que ya no existen.
 */
const DetailPayment = ({
  clientId,
  selectedTickets,
  setSelectedTickets,
  setTotalExpenses,
  setTotalExpensesWithIva,
  setTotalIva210,
  setTotalIva105
}) => {
  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <TicketsScreen
        clientId={clientId}
        isAdmin={true}
        selectedTickets={selectedTickets}
        setSelectedTickets={setSelectedTickets}
        setTotalExpenses={setTotalExpenses}
        setTotalExpensesWithIva={setTotalExpensesWithIva}
        setTotalIva210={setTotalIva210}
        setTotalIva105={setTotalIva105}
      />
    </Box>
  );
};

export default DetailPayment;
